export const TYPE_MODAL = {
  EVALUATE: "evaluate",
  EDIT: "edit",
  VIEW: "view",
};

export const LEVEL_CIRTERIA = [
  { id: 1, name: "Mức 1" },
  { id: 2, name: "Mức 2" },
  { id: 3, name: "Mức 3" },
  { id: 4, name: "Mức 4" },
  { id: 5, name: "Mức 5" },
];

export const RESULT = [
  { id: 1, name: "Đạt" },
  { id: 2, name: "Không đạt" },
];

export const SURGICAL_SAFETY_RESULT = {
  ACHIEVED: {id: 1, name: "Đạt", multiplier: 1},
  PARTIALLY_ACHIEVED_BELOW: {id: 2, name: "Đạt một phần < 50%", multiplier: 0},
  PARTIALLY_ACHIEVED_ABOVE: {id: 3, name: "Đạt một phần >= 50%", multiplier: 0.5},
  NOT_ACHIEVED: {id: 4, name: "Không đạt", multiplier: 0}
};

export const EVALUATE_STATUS = {
  NOT_RATE_YET: {
    code: 1,
    name: "Chưa đánh giá",
  },
  EVALUETING: {
    code: 2,
    name: "Đang đánh giá",
  },
  EVALUATED: {
    code: 3,
    name: "Đã đánh giá",
  },
};

export const TYPE_CONFIRM_DIALOG = {
  COMPLETE_EVALUATE: "completeEvaluate",
};

export const MESSAGE_CONFIRM_DIALOG = {
  [TYPE_CONFIRM_DIALOG.COMPLETE_EVALUATE]:
    "Bạn có chắc chắn muốn hoàn thành đánh giá các tiêu chí đã chọn không?",
};
